import angular from "angular";

import AdminAnalyticsModuleRouting from "./admin-analytics.module.routing";

export default angular
  .module("vt-admin-analytics", [])
  .config(AdminAnalyticsModuleRouting);
